import { getAppNavigationSections } from './navigation';

export type PrimarySection = 'chat' | 'work' | 'agents' | 'site' | 'canvas' | 'data' | 'library' | 'tools' | 'settings';

/** Derive the secondary rail from the URL so deep links and browser history stay in sync. */
export function getPrimarySection(
  pathname: string,
  params: { get: (key: string) => string | null },
): PrimarySection {
  const mode = pathname === '/app/workspace' ? params.get('mode') : null;
  if (pathname === '/app/workspace' && (!mode || mode === 'chat')) {
    if (params.get('editor') === 'website') return 'site';
    if (params.get('editor') === 'canvas') return 'canvas';
  }
  if (/^\/app\/(settings|admin)(\/|$)/.test(pathname)) return 'settings';
  if (/^\/app\/(agents)(\/|$)/.test(pathname) || mode === 'agents') return 'agents';
  if (
    /^\/app\/(objectives|key-results|plans|tasks|north-star)(\/|$)/.test(pathname) ||
    mode === 'tasks' ||
    mode === 'growth-program'
  )
    return 'work';
  if (/^\/app\/(docs|reports)(\/|$)/.test(pathname)) return 'library';
  if (/^\/app\/(plugins|skills|mcp|custom-mcp)(\/|$)/.test(pathname) || mode === 'integrations')
    return 'tools';
  if (
    pathname === '/app/data-explorer' ||
    mode === 'data' ||
    /^\/app\/(brands|ai-search)(\/|$)/.test(pathname)
  )
    return 'data';
  if (
    getAppNavigationSections()
      .filter(section => section.title !== 'Home')
      .some(section =>
        section.items.some(item => pathname === item.href || pathname.startsWith(`${item.href}/`)),
      )
  )
    return 'data';
  return 'chat';
}
